export default {
  /*
    use this namespace translate the long message/sentence in the app
    e.g.
    invalid_email: 'Invalid email address! Consider using a different email address.',
  */
  cannot_remove_the_only_remaining_do: 'You can\'t remove the only remaining DO',
  cod_amount_must_integer: 'COD Amount must not be in Decimals in row {{x}}',
  dedicated_contract_driver_missing_contract_ksuid: 'Dedicated to Contract Driver needs Contract Ksuid',
  do_planned_pricing_unit_should_be_unique: 'DO Planned Pricing Unit should have the same value for 1 Tour ID',
  failed_upload_message: 'Failed to upload',
  file_type_is_not_supported: 'File type is not supported',
  hold_reason_is_a_required_field: 'Hold Reason is a required field',
  invalid_format_additional_trip: 'Please fill in Additional Trip column with YES (for on call driver) and NO (for dedicated driver). Leave it blank for on call and dedicated driver',
  invalid_identifier_project: 'Plase Fill Type of App with one of these option: WA_BOT, FLYND, NON_APP',
  input_item_details: 'Input Item Details in row {{x}}',
  ksuid_need_to_update_existing_data: 'Ksuid needed to update existing data',
  leave_form_warning: 'Your changes will not be saved',
  leave_this_page_question: 'Do you want to leave this page?',
  no_data_yet_waiting_for_assignment: 'No data yet. Waiting for assignment',
  payment_amount_before_tax: 'The payment amount shown excludes tax.',
  payment_working_days_not_exist: 'Payment Working Days does not exist',
  pending_definition: '*Pending = payment is still being processed',
  pot_upload_successfully: 'POT Upload Successfully',
  routing_ksuid_needed_to_convert_do: 'Routing ksuid needed to convert routing to DO',
  search_by_contract_code_or_transporter_name: 'Search By Contract Code or Transporter Name',
  search_by_transporter_name_or_phone: 'Search By Transporter Name or Phone',
  search_fleet_by_license_plate: 'Search Fleet By License Plate',
  shipment_status_only_accept_unfulfilled: 'Shipment status in Allocation only accept \'Unfulfilled\'',
  some_mandatory_field_was_not_provided: 'Some mandatory field was not provided',
  this_field_is_required: 'This field is required',
  update_automatically_saved: 'All updates will be automatically saved',
  upload_creation_failed_tpt_price: 'Decimals in transporter_price should use dot (.) symbol',
  upload_creation_failed_ksuid: 'Ksuid field must be empty',
  upload_failed_invalid_fleet_dimension: 'Fleet dimension must be in LxWxH format and using dot(.) as float number identifier',
  upload_success_fully: 'Success on uploading all row',
  upload_success_partialy: 'Partially success on uploading data',
  vcc_data_length_invalid: 'Amount of VCC End Data, VCC Start Date, Vehicle Contract Status, and Replacement For must have same amount with Fleet Quantity ',
  vcc_end_date_mandatory: 'VCC End date is Mandatory',
  vcc_start_date_mandatory: 'VCC Start date is Mandatory',
  vehicle_id_does_not_exist: 'Fleet Type or Fleet Body Type does not exist',
};
